import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkout-forms--license-plate-state"
//
// Follows the picked car wash location, since one location group can span countries.
export default class extends Controller {
  static targets = ["label", "select"];
  static values = {
    country: String,
    optionsByCountry: Object,
  };

  update({ detail: { country } }) {
    const options = this.optionsByCountryValue[country];
    if (!options || country === this.countryValue) return;

    this.countryValue = country;
    this.setOptions(options);
    this.setLabel();
  }

  setOptions(options) {
    const previous = this.selectTarget.value;

    this.selectTarget.replaceChildren(
      ...options.map(({ name, code }) => new Option(name, code ?? ""))
    );

    // A plate from the other country isn't valid here, so drop a selection that no longer exists.
    this.selectTarget.value = options.some(({ code }) => code === previous) ? previous : "";
  }

  setLabel() {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.countryValue === "United States" ? "State" : "Province";
    }
  }
}
